export default __webpack_public_path__ + "static/char-59-anr-ad31f784ebab50eba255deffae6169da.gif";